import { createFileRoute, redirect } from '@tanstack/react-router';

// Payments is a tabbed section, not a page of its own — the sidebar entry lands
// on the first tab.
export const Route = createFileRoute('/(app)/company/payments/')({
	beforeLoad: () => {
		throw redirect({ to: '/company/payments/employee', replace: true });
	},
});
